import { createRouter, createWebHistory } from 'vue-router'
import HelloWorld from '@/components/HelloWorld.vue'
import ProductCenter from '@/views/ProductCenter.vue'
import AboutUs from '@/views/AboutUs.vue'
import ProductDetail from '@/views/ProductDetail.vue'
import ArticleList from '@/views/Articles.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HelloWorld
  },
  {
    path: '/products',
    name: 'Products',
    component: ProductCenter
  },
  {
    path: '/about',
    name: 'About',
    component: AboutUs
  },
  {
    path: '/product/:id',
    name: 'ProductDetail',
    component: ProductDetail,
    props: true
  },
  {
    path: '/articles',
    name: 'Articles',
    component: ArticleList
  }
]

const router = createRouter({
  // history: createWebHashHistory(),
  history: createWebHistory(),
  routes
})

export default router 